import { render, staticRenderFns } from "./directDebitLegalsEditor.vue?vue&type=template&id=22690194&"
import script from "./directDebitLegalsEditor.vue?vue&type=script&lang=js&"
export * from "./directDebitLegalsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports